var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-circle-step",class:{
    'app-circle-step_state_active': _vm.isActive
  }},[_vm._v(" "+_vm._s(_vm.num)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }